import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tank-move-status',
  templateUrl: './tank-move-status.component.html',
  styleUrls: ['./tank-move-status.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TankMoveStatusComponent {
  /* table  */
  displayedColumns: string[] = [
    'tankName',
    'minNumber',
    'rtuNumber',
    'previousBillableOrganizationName',
    'previousOrganizationName',
    'previousLocationName',
    'newOrganizationName',
    'newBillableOrganizationName',
    'newLocationName',
    // The affiliate each tank holds AFTER the move, blank when it has none. Sits beside the other
    // "new" columns because it is another thing the move decided rather than something the user chose.
    // The shared status table resolves its header as 'MoveForms.General.' + the column name with the
    // first letter upper-cased, so this reuses the key Move Locations already added.
    'affiliatedOrganizationName',
    'dateStamp_Formatted',
    'userName',
    'status',
  ];
  dataSource: any;
  showToListButton: boolean = false;
  exportToExcelFileName: any;

  /* resource keys */
  title = 'MoveForms.TankMove.MoveTank';
  subtitle = 'MoveForms.TankMove.Status.Subtitle';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { results: any[]; showToListButton: boolean; exportToExcelFileName : any },
    public dialogRef: MatDialogRef<
      TankMoveStatusComponent,
      { sendToList: boolean }
    >,
    public router: Router,
  ) {
    dialogRef.disableClose = true;
    this.initializeForm(data);
  }

  onCloseButtonClick() {
    this.dialogRef.close({ sendToList: false });
  }

  onToListButtonClick() {
    //apply the filter to the tanks list then navigate to the tanks list page
    this.dialogRef.close({ sendToList: true });
  }

  private initializeForm(data: any) {
    this.dataSource = data?.results ?? [];
    this.showToListButton = data?.showToListButton ?? false;
    this.exportToExcelFileName = data?.exportToExcelFileName ?? '';
  }
}
